'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (file) {
  var iFrameId = 'miHoYoDownloadIFrame';
  var iFrame = document.querySelector('' + iFrameId);

  if (!iFrame) {
    iFrame = document.createElement('iframe');
    iFrame.setAttribute('id', iFrameId);
    document.body.appendChild(iFrame);
  }

  iFrame.setAttribute('src', file);
};